module.exports = __webpack_public_path__ + "img/e4abf1a.jpg";